import React from "react"
import * as htmlparser2 from "htmlparser2"

import { TResolvedTextsList } from "@/lib/kontent/components/getTextsList"

import { SimpleList } from "./SimpleList"

type TSimpleListResolverProps = {
  resolvedData: TResolvedTextsList
  isInArticle: boolean
}

type ParsedListItem = {
  text: string
}

function parseList(list: string) {
  let parsedList: ParsedListItem[] = []
  let isOpen = false

  let parser = new htmlparser2.Parser({
    onopentag(name) {
      if (name === "li") {
        parsedList.push({
          text: "",
        })
        isOpen = true
      }

      if (isOpen && name !== "li") {
        parsedList[parsedList.length - 1].text += "<" + name + ">"
      }
    },
    ontext(text) {
      if (parsedList[parsedList.length - 1] && isOpen) {
        parsedList[parsedList.length - 1].text += text
      }
    },
    onclosetag(name) {
      if (name === "li") {
        isOpen = false
      }

      if (isOpen && name !== "li" && name !== "br") {
        parsedList[parsedList.length - 1].text += "</" + name + ">"
      }
    },
  })

  parser.write(list)
  parser.end()

  return parsedList
}

const SimpleListResolver = ({
  resolvedData,
  isInArticle,
}: TSimpleListResolverProps) => {
  const kontentData = {
    title: resolvedData.title,
    isInArticle: isInArticle,
    list: parseList(resolvedData.textList).map((item) => item.text),
  }

  return <SimpleList {...kontentData} />
}

export { SimpleListResolver, type TSimpleListResolverProps }
